import React from 'react';
import clsx from 'clsx';
import { Chip } from '@material-ui/core';

import { useStyles } from './styles';
import { useTranslation } from 'hooks/useTranslation';
import { T2 } from 'ts/translation';

export type CardColorScheme = 'active' | 'redeemed' | 'canceled' | 'expired';

interface CardStatusProps {
  colorScheme: CardColorScheme;
}


export const CardStatus: React.FC<CardStatusProps> = ({ colorScheme}) => {
  const classes = useStyles();
  const { t } = useTranslation('redemptions');

  const label_mapping: Record<CardColorScheme, T2> = {
    active: t("filters.tabs.active"),
    redeemed: t("filters.tabs.redeemed"),
    canceled: t("filters.tabs.canceled"),
    expired: t("filters.tabs.expired")
  }

  const label_name = label_mapping[colorScheme]

  return <Chip className={clsx(classes.chip, classes[colorScheme])} label={label_name} />;
};
